import { render, staticRenderFns } from "./CurrentData.vue?vue&type=template&id=59fe6f8a&scoped=true&"
import script from "./CurrentData.vue?vue&type=script&lang=js&"
export * from "./CurrentData.vue?vue&type=script&lang=js&"
import style0 from "./CurrentData.vue?vue&type=style&index=0&id=59fe6f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fe6f8a",
  null
  
)

export default component.exports